// extracted by mini-css-extract-plugin
export default {"LocSubscribersField":"_3ZUlCfGOZkXmGcwI8CXNZ7","addRow":"_1TxaLEYOLLsC1XoZkdILSN"};